import { render } from "./StudentOnClass.vue?vue&type=template&id=35920ff6&scoped=true"
import script from "./StudentOnClass.vue?vue&type=script&lang=js"
export * from "./StudentOnClass.vue?vue&type=script&lang=js"

import "./StudentOnClass.vue?vue&type=style&index=0&id=35920ff6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35920ff6"]])

export default __exports__